import { wrapTextNodes } from './_wrapTextNodes';

export function letterTypewriter() {
  const els = document.querySelectorAll('.letter-typewriter');
  if (els.length) {
    els.forEach(container => {
      const speed = parseFloat(container.getAttribute('data-speed')) || 1;
      const fadeInDuration = parseFloat(container.getAttribute('data-fade-in-duration')) || 0.1; // フェードインの速度（秒）
      const rootMargin = container.getAttribute('data-root-margin') || '0px 0px -10% 0px'; // フェードイン開始位置
      const stutterThreshold = parseFloat(container.getAttribute('data-stutter-threshold')) || 0.1; // どもる確率の閾値
      const stutterRange = parseInt(container.getAttribute('data-stutter-range')) || 5; // 戻り幅の範囲

      const animateEnabled = container.getAttribute('data-animate-enabled') || 'true';
      const maxMove = parseFloat(container.getAttribute('data-max-move')) || 0.2;
      const minMove = parseFloat(container.getAttribute('data-min-move')) || 0.075;
      const maxSpeed = parseInt(container.getAttribute('data-max-speed')) || 6000;
      const minSpeed = parseInt(container.getAttribute('data-min-speed')) || 3000;
      const maxScale = parseFloat(container.getAttribute('data-max-scale')) || 1.1;
      const minScale = parseFloat(container.getAttribute('data-min-scale')) || 0.9;

      wrapTextNodes(container);
      container.classList.add('is-init');
      const letters = Array.from(container.querySelectorAll('.letter'));

      // 半角スペースを正規表現で&nbsp;に置き換え
      letters.forEach(letter => {
        // 正規表現で半角スペースを探し、&nbsp;に置き換える
        letter.innerHTML = letter.innerHTML.replace(/ /g, '&nbsp;');
      });

      // IntersectionObserverを設定
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            let index = 0;
            function typeLetter() {
              if (index < letters.length) {
                const letter = letters[index];
                letter.style.transition = `opacity ${fadeInDuration}s ease`; // フェード時間を指定
                letter.style.opacity = 1;
                index++;

                // どもり効果の判定
                if (Math.random() < stutterThreshold && index > 2) {
                  const stutterAmount = Math.floor(Math.random() * stutterRange) + 1; // 1～指定された範囲まで戻る
                  const stutterIndex = Math.max(index - stutterAmount, 0);

                  // 文字を戻す
                  for (let i = index - 1; i >= stutterIndex; i--) {
                    letters[i].style.opacity = 0;
                  }

                  index = stutterIndex;
                }

                if (animateEnabled === 'true') { // アニメーションが有効な場合のみ実行
                  const animateLetter = () => {
                    const xMove = (Math.random() * (maxMove - minMove) + minMove) * (Math.random() < 0.5 ? -1 : 1);
                    const yMove = (Math.random() * (maxMove - minMove) + minMove) * (Math.random() < 0.5 ? -1 : 1);
                    const moveDuration = Math.random() * (maxSpeed - minSpeed) + minSpeed;
                    const scaleValue = Math.random() * (maxScale - minScale) + minScale;

                    letter.animate([
                      { transform: `translate(0, 0) scale(1)` },
                      { transform: `translate(${xMove}rem, ${yMove}rem) scale(${scaleValue})` }
                    ], {
                      duration: Math.max(moveDuration, 0),
                      easing: 'linear',
                      iterations: Infinity,
                      direction: 'alternate',
                      fill: 'forwards'
                    });
                  };

                  animateLetter();
                }

                setTimeout(typeLetter, speed * 100);
              }
            }

            typeLetter();
            observer.unobserve(container);
          }
        });
      }, {
        rootMargin: rootMargin
      });

      // 監視対象に要素を追加
      observer.observe(container);
    });
  }
}